export const InstallationFailureMessage = "Installation Error : CartBob not installed, reach out to shipbob support"
export const InstallatioSuccessMessage = "CartBob installation successful, You are all set!" 